import React, { Component } from 'react';
import { Form, Input, Label, Button } from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class Cor extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="Cor">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="Cor__Form"
        >
          <h1>{translate('fiche.muscle_movement_system.title')}</h1>
          <h2>{translate('fiche.muscle_movement_system.dynamometry')}</h2>

          <div className="Form__Horizontal">
            <div className="Form__Horizontal__Item">
              <Label text={translate('right')} />
              <Input
                name="dynamometry_right"
                rules={['required']}
                defaultValue={data.dynamometry_right}
              />
            </div>
            <div className="Form__Horizontal__Item">
              <Label text={translate('left')} />
              <Input
                name="dynamometry_left"
                rules={['required']}
                defaultValue={data.dynamometry_left}
              />
            </div>
          </div>

          <h2>{translate('fiche.muscle_movement_system.compassion')}</h2>
          <Label
            text={translate('fiche.muscle_movement_system.schober_test')}
          />
          <div className="Form__Horizontal">
            <div className="Form__Horizontal__Item">
              <Input
                name="schober_test_1"
                rules={['required']}
                defaultValue={data.schober_test_1}
              />
            </div>
            <div className="Form__Horizontal__Item">
              <Input
                name="schober_test_2"
                rules={['required']}
                defaultValue={data.schober_test_2}
              />
            </div>
          </div>
          <Label
            text={translate('fiche.muscle_movement_system.finger_soil_test')}
          />
          <Input
            name="finger_soil_test"
            rules={['required']}
            defaultValue={data.finger_soil_test}
          />

          <h2>{translate('fiche.muscle_movement_system.muscle_research')}</h2>
          <Label text={translate('fiche.muscle_movement_system.arms')} />
          <Input name="arms" rules={['required']} defaultValue={data.arms} />
          <Label text={translate('fiche.muscle_movement_system.legs')} />
          <Input name="legs" rules={['required']} defaultValue={data.legs} />

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(Cor);
